import path from 'node:path';
import { ApiClient } from '../client.js';
import { DEFAULT_PRODUCT_NAME } from '../constants.js';
import { readAppConfig } from '../lib/appConfig.js';
import { renderStateTable, summarizeState, type StateResource } from '../lib/stateTable.js';
import { resolveProfile } from '../profiles.js';
import { emitJson, fail, human, type Io } from '../output.js';

export async function runState(options: {
  dir?: string;
  json?: boolean;
  adminUrl?: string;
}): Promise<void> {
  const io: Io = { json: options.json === true, productName: DEFAULT_PRODUCT_NAME };
  const dir = path.resolve(process.cwd(), options.dir ?? '.');

  const resolved = resolveProfile(options.adminUrl, undefined, dir);
  if (!resolved) fail(io, 'Not signed in. Run `ghosty login` first.', 1, 'NOT_LOGGED_IN');
  io.productName = resolved.profile.branding?.productName ?? DEFAULT_PRODUCT_NAME;

  let slug: string;
  try {
    slug = readAppConfig(dir).slug;
  } catch (err) {
    fail(io, (err as Error).message, 1, 'BAD_APP_TREE');
  }

  const client = new ApiClient(resolved.adminUrl, resolved.profile.token);
  try {
    const state = await client.get<{ slug: string; resources: StateResource[] }>(
      `/blocks/state/${slug}`,
    );
    if (io.json) {
      emitJson({ ok: true, slug, summary: summarizeState(state.resources), resources: state.resources });
      return;
    }
    if (state.resources.length === 0) {
      human(io, `No platform resources yet for ${slug}. Run \`ghosty provision\`.`);
      return;
    }
    human(io, renderStateTable(state.resources));
  } catch (err) {
    fail(io, (err as Error).message, 1, 'API_ERROR');
  }
}
